module.exports = __webpack_public_path__ + "img/231.0bce99ba.jpg";